
export default {
    name: 'view-ordonnance',
    components: {},
    props: {
        info_ordonnance: Array,
        vente_id: Number
    },
    data () {
        return {

        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {

    }
}
